import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';
import { Navigator } from '../../components/menu/navigator';
import { ProgressingComponent } from '../../components/progressing/progressing.component';

@Component({
	selector: 'app-location-warning',
	templateUrl: './location-warning.component.html',
	styleUrls: ['./location-warning.component.scss'],
})

export class LocationWarningComponent implements OnInit {
	@ViewChild(ProgressingComponent) progressingUI!: ProgressingComponent;
	@Input() callBackFn: () => void;
	textContent: Record<string, string> = {};
	public loading: any;
	public isAuthenticated: boolean = false;


	constructor(
		private navigator: Navigator,
		private siteContentService: SiteContentService,
		public loadingController: LoadingController,
	) { }

	ngOnInit(): void {
		sessionStorage.setItem('locationWarningSeenByUser', 'true');
	}

	ngAfterViewInit() {
		this.siteContentService
			.loadConfig('location_warning')
			.then((response: Record<string, string>) => {
				this.textContent = response;
			});
	}

	onClose = () => {
		if (this.callBackFn) this.callBackFn();
		this.navigator.dismiss();
	}


}
